import { Flex, Text, CircularProgress, IconButton } from '@chakra-ui/react'
import { FC } from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import { useHistory, useLocation } from 'react-router-dom'

import useSessions from '@hook/shared/use-sessions'

interface IBackgroundTasksItemProps {
  name: string
  path: string
  loading: boolean
}

const BackgroundTasksItem: FC<IBackgroundTasksItemProps> = ({
  name,
  path,
  loading
}) => {
  const router = useHistory()

  const { unregister, sessions } = useSessions()
  const location = useLocation()

  const handleClick = () => {
    router.push(path)
  }

  const closed = () => {
    if (path === location.pathname) {
      const sessiosActive = sessions.filter(x => x.path !== location.pathname)
      unregister(name)
      router.push(sessiosActive.length > 0 ? sessiosActive[0].path : '/')
    } else {
      unregister(name)
    }
  }

  return (
    <Flex
      bg="green.600"
      px={3}
      pr={2}
      h="48px"
      alignItems="center"
      transition="all ease .3s"
      borderRadius={4}
      _hover={{
        mt: -2,
        bg: 'green.500'
      }}
    >
      <Flex alignItems="center" mr={2} cursor="pointer">
        <Text
          onClick={handleClick}
          fontWeight="600"
          fontSize="12px"
          color="#fff"
          maxW="112px"
          isTruncated
          mr={4}
        >
          {name}
        </Text>
        {loading ? (
          <CircularProgress
            color="black"
            size="20px"
            thickness="8px"
            isIndeterminate
          />
        ) : (
          <IconButton
            aria-label="Cancelar"
            size="xs"
            color="white"
            bg="rgba(0, 0, 0, 0.2)"
            icon={<AiOutlineClose />}
            _hover={{
              bg: 'rgba(0, 0, 0, 0.3)'
            }}
            _active={{
              bg: 'rgba(0, 0, 0, 0.4)'
            }}
            onClick={() => closed()}
            isRound
          />
        )}
      </Flex>
    </Flex>
  )
}

export default BackgroundTasksItem
